import {AxiosResponse} from "axios";
import {$api} from "../api/api.ts";
import {getToken} from "../../utils/Utils.ts";
import {ICategoriesResponseData} from "../models/CategoriesResponse.ts";


export const CategoriesService = {
    fetchCategoriesData(): Promise<AxiosResponse<ICategoriesResponseData[]>> {
        return $api.get('/categories', {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },

}
